<!--
  试郑试题编辑
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">

    <!-- 浮动快捷 -->
    <div class="divFloatBox">
      <div class="itemBox" :style="'border-color:'+item.color+' ;'" v-for="(item,index) in fastData"
        :key="index+'_fast'">
        <div class="divNum VerticalMid" :style="'color:'+item.color+';'">
          {{item.number.length}}
        </div>
        <div class="divName" :style="'background-color:'+item.color+';'">{{item.name}}</div>
      </div>
      <div class="itemBox fastTotal mt-3">
        <div class="divNum VerticalMid">
          {{totalInfo.count}}
        </div>
        <div class="divName">总题数</div>
      </div>
      <div class="itemBox fastTotal">
        <div class="divNum VerticalMid">
          {{totalInfo.score}}
        </div>
        <div class="divName">总分数</div>
      </div>
      <div class="itemAddBox" @click="onOpenBank()">
        <div class="divIcon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#fax-circle-plus-alt"></use>
          </svg>
        </div>
        <div class="divName">
          新增题目
        </div>
      </div>
      <!-- <div class="itemEditBox" v-if="!isBtnEdit">
        <div class="divIcon">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#fax-file-edit-o"></use>
          </svg>
        </div>
        <div class="divName">
          编辑试卷
        </div>
      </div> -->
    </div>


    <!-- 试卷基本信息 -->
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          试卷基本信息
        </h3>
      </div>
      <div class="card-body" v-if="!regNull(infoForm)">
        <div class="divTitleBox">
          {{infoForm.name}}
        </div>
        <div class="divSubTitle">
          {{infoForm.semester}}
          {{regNull(infoForm.courseName)?'':' &bull; '+infoForm.courseName}}
        </div>
        <div class="divSubTitle">
          {{infoForm.paperTypeName}}{{infoForm.questionDisorder?' &bull; 题目乱序':''}}{{infoForm.choiceDisorder?' &bull; 选项乱序':''}}
        </div>
        <div class="divDateCont">
          <b class="color-danger">{{infoForm.startDate | dateformatMinute}}</b> 至 <b
            class="color-danger">{{infoForm.endDate | dateformatMinute}}</b>
        </div>
        <div class="divDesc" v-if="!regNull(infoForm.description)">
          {{infoForm.description}}
        </div>
      </div>
      <div class="card-body " v-else>
        <el-empty :image-size="200" description="暂无数据"></el-empty>
      </div>
    </el-card>

    <div v-if="!regNull(alertFont)" class="mb-3">
      <el-alert :title="alertFont" type="warning">
      </el-alert>
    </div>



    <!-- 试卷试题内容 -->
    <div v-if="!regNullArray(itemData)" class="mt-3">
      <draggable v-model="itemData" group="itxst" chosenClass="chosen" filter=".forbid" animation="100" :move="onMove">
        <transition-group class="groupBox">
          <el-card class="box-card" v-for="(item,indexList) in itemData" :key="indexList+'_question'">
            <div slot="header" class="card-header cardHeaderCont">
              <h3 class="card-title cardTitleCont">
                {{indexList+1}}、{{item.name}}
              </h3>
              <div class="card-subCont">
                <span class="spItem">
                  <el-tag type="info">答案：<b class="color-danger">{{onGetAnswer(item)}}</b></el-tag>
                </span>
                <span class="spItem">
                  <el-tag type="info">难易程度：<b class="color-danger">{{item.levelName}}</b></el-tag>
                </span>
                <span class="spItem">
                  <el-tag type="info">题型：<b class="color-danger">{{item.questionTypeStr}}</b></el-tag>
                </span>
                <span class="spItem">
                  <el-tag type="info">分值：<b class="color-danger">{{item.point}}</b></el-tag>
                </span>
              </div>
              <div class="btnDelCont">
                <el-button type="danger" plain size="small" @click="onDelQuestion(item.questionId)">删除</el-button>
              </div>
            </div>

            <div class="card-body pl-5" v-if="!regNullArray(item.choices)">
              <el-row :gutter="24">
                <el-col :span="12" class="colItemBox" v-for="(list,indexTwo) in item.choices" :key="indexTwo">
                  <span :class="{'color-danger':list.right}">{{optLetter[indexTwo]}}、{{list.name}}</span>
                </el-col>
              </el-row>
            </div>
          </el-card>

        </transition-group>
      </draggable>

    </div>
    <div v-else>
      <el-card class="box-card">
        <div class="card-body ">
          <el-empty :image-size="200" description="暂无考试题目数据"></el-empty>
        </div>
      </el-card>
    </div>


    <el-dialog title="新增题目" :visible.sync="dialogVisible" width="95%" :before-close="handleClose">
      <el-form :model="dialogForm" ref="dialogForm" label-width="80px">
        <div class="pr-4">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="题库" prop="name">
                <el-select v-model="dialogForm.bankId" placeholder="请选择题库" class="width_100Pie" @change="onChangeBank">
                  <el-option v-for="item in optBank" :key="item.id+'_bank'" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="章节" prop="name">
                <el-select v-model="dialogForm.category" placeholder="请选择" class="width_100Pie"
                  @change="onChangeCategory">
                  <el-option v-for="item in optCategory" :key="item+'_cate'" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="默认分值" prop="name">
                <el-input v-model="dialogForm.point" placeholder="请输入默认分值" class="width_100Pie"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="!regNullArray(dialogData)">
              <el-table :data="dialogData" class="tbDialogTable" max-height="400" border style="width: 100%"
                :header-cell-class-name="headerStyle">
                <el-table-column type="index" label="序号" width="60">
                </el-table-column>
                <el-table-column prop="name" label="题目" min-width="200">
                </el-table-column>
                <el-table-column prop="levelName" label="难易程序" width="100">
                </el-table-column>
                <el-table-column label="分值" width="80">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.point" placeholder="分值" :disabled="!scope.row.checked"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60">
                  <template slot-scope="scope">
                    <div class="VerticalMid tdCheckBox">
                      <el-checkbox v-model="scope.row.checked" @change="onChangeCheck(scope.row)"></el-checkbox>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="onCreateQuestion">确 定</el-button>
      </span>
    </el-dialog>


    <div class="pt-10 pb-5">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
          <el-button icon="el-icon-refresh" @click="onReset()">重 置</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="onSave()">提交试卷</el-button>
        </el-col>
        <el-col :span="12" class="text-right">
          <el-button @click="onSwitch()">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#fax-arrow-toggle-alt"></use>
            </svg>
            切换至按模板组卷
          </el-button>
        </el-col>
      </el-row>
    </div>

  </div>


</template>

<script>
  import '@/assets/css/Admin.css';
  import draggable from 'vuedraggable';
  export default {
    components: {
      draggable
    },
    data() {
      return {
        fullscreenLoading: false,
        // 是否显示试卷
        isBtnEdit: false,
        infoForm: null,
        alertFont: '',
        // 快捷菜单
        fastData: [],

        // 试卷基本信息
        ruleForm: {
          paperId: null,
          questions: [],
        },


        // 统计总题数，总分
        totalInfo: {
          count: 0,
          score: 0,
        },

        // 试题信息
        itemData: [],
        // 获取字母数组
        optLetter: onGetLetter(),

        // 弹出框
        dialogVisible: false,
        dialogForm: {
          bankId: null,
          category: null,
          point: 2,
          NullVal: null,
        },
        allDialogData: [],
        dialogData: [],
        // 题库数组
        optBank: [],
        // 章节数组
        optCategory: [],
      };
    },
    created() {
      let that = this;
      if (!regNull(that.$route.params.Id)) {
        that.ruleForm.paperId = that.$route.params.Id;
        that.fullscreenLoading = true;
        ajaxGet(that, '/api/admin/paper/' + that.$route.params.Id, null, function(resPaper) {


          ajaxGet(that, '/api/admin/paper/question/' + that.ruleForm.paperId, null, function(resQuestion) {
            that.fullscreenLoading = false;

            that.infoForm = resPaper;
            if (resPaper.questionDisorder) {
              that.alertFont += '已设置题目乱序，学生考试期间每次打开试卷，题目将以乱序方式排列；'
            }
            if (resPaper.choiceDisorder) {
              that.alertFont += '已设置选项乱序，题目的选项将以乱序方式排列；'
            }
            if (!regNullArray(resQuestion.questions)) {
              that.itemData = [];
              resQuestion.questions.forEach((item, index) => {
                that.itemData.push({
                  questionId: getTimeID() + Math.floor(Math.random() * (100000 - 1 + 1)) + 10000,
                  index: index,
                  questionType: item.questionType,
                  questionTypeStr: item.questionType,
                  name: item.name,
                  point: item.point,
                  level: item.level,
                  levelName: item.levelName,
                  category: item.category,
                  analysis: item.analysis,
                  choices: item.choices,
                });
              });
            }
            // that.itemData = resQuestion.questions;
            that.onGetFast(that);
          });


        });
      }

    },
    methods: {
      /**
       * @description 切换
       */
      onSwitch() {
        let that = this;
        confirmDelete(that, '切换后当前页面手动添加的题目会丢失，确认继续切换至按模板组卷吗？', function(res) {
          if (res == true) {
            that.$router.push({
              path: "/Admin/EducationalAffairs/ExamMGT/TestPaper/Auto/" + that.ruleForm.paperId,
              query: {
                url: that.$route.query.url
              }
            });
          }
        })
      },
      /**
       * @description 重置
       */
      onReset() {
        let that = this;
        that.fullscreenLoading = true;
        ajaxGet(that, '/api/admin/paper/' + that.ruleForm.paperId, null, function(resPaper) {
          that.fullscreenLoading = false;

          that.infoForm = resPaper;
          if (resPaper.questionDisorder) {
            that.alertFont += '已设置题目乱序，学生考试期间每次打开试卷，题目将以乱序方式排列；'
          }
          if (resPaper.choiceDisorder) {
            that.alertFont += '已设置选项乱序，题目的选项将以乱序方式排列；'
          }

          ajaxGet(that, '/api/admin/paper/question/' + that.ruleForm.paperId, null, function(resQuestion) {
            if (!regNullArray(resQuestion.questions)) {
              that.itemData = [];
              resQuestion.questions.forEach((item, index) => {
                that.itemData.push({
                  questionId: getTimeID() + Math.floor(Math.random() * (100000 - 1 + 1)) + 10000,
                  index: index,
                  questionType: item.questionType,
                  questionTypeStr: item.questionType,
                  name: item.name,
                  point: item.point,
                  level: item.level,
                  levelName: item.levelName,
                  category: item.category,
                  analysis: item.analysis,
                  choices: item.choices,
                });
              });
            }
            // that.itemData = resQuestion.questions;
            that.onGetFast(that);
          });


        });

      },
      /**
       * @description 勾选题目事件
       * @param {Object} objItem
       */
      onChangeCheck(objItem) {
        let that = this;
        that.dialogData.forEach((item) => {
          if (item.questionId == objItem.questionId) {
            if (objItem.checked) {
              // item.point = JSON.parse(JSON.stringify(that.dialogForm.point));
              that.$set(item, "point", that.dialogForm.point);
            } else {
              that.$set(item, "point", null);
            }
          }
        });

      },
      /**
       * @description 提交试卷
       */
      onSave() {
        let that = this;
        if (!regNullArray(that.itemData)) {
          let tpParams = {
            paperId: that.ruleForm.paperId,
            questions: []
          }
          that.itemData.forEach((item, index) => {
            tpParams.questions.push({
              index: index,
              questionType: item.questionType,
              name: item.name,
              point: item.point,
              level: item.level,
              category: item.category,
              analysis: item.analysis,
              choices: item.choices,
            });
          });

          that.fullscreenLoading = true;
          ajaxPut(that, '/api/admin/paper/question/' + that.ruleForm.paperId, tpParams, function(res) {
            that.fullscreenLoading = false;
            that.onBack();
          });
        } else {
          warning(that, '未设置题目')
        }

      },
      /**
       * @description Table 头部样式
       */
      headerStyle({
        row,
        rowIndex
      }) {
        return 'headerColor';
      },

      /**
       * @description 新增题目
       */
      onCreateQuestion() {
        let that = this;

        // let tpData = [];

        if (!regNullArray(that.dialogData)) {
          that.dialogData.forEach((item) => {
            if (item.checked) {
              if (regNull(that.itemData.find(it => it.name == item.name))) {
                that.itemData.push(item);
              }
            }
          });
        }
        setTimeout(function() {
          that.handleClose();
          that.onGetFast(that);
          return false;
        }, 100);

      },
      /**
       * @description 章节选择事件
       * @param {Object} objItem
       */
      onChangeCategory(objItem) {
        let that = this;
        if (!regNull(objItem)) {
          if (objItem == '全部') {
            that.dialogData = [];
            that.allDialogData.forEach((item) => {
              that.dialogData.push({
                questionId: item.questionId,
                index: item.index,
                questionType: item.questionType,
                questionTypeName: item.questionTypeName,
                name: item.name,
                level: item.level,
                levelName: item.levelName,
                category: item.category,
                analysis: item.analysis,
                choices: item.choices,
                checked: false,
                point: null,
              })
            })
            // that.dialogData = JSON.parse(JSON.stringify(that.allDialogData));
          } else {
            let temp = that.allDialogData.filter(item => item.category == objItem);
            that.dialogData = [];
            temp.forEach((item) => {
              that.dialogData.push({
                questionId: item.questionId,
                index: item.index,
                questionType: item.questionType,
                questionTypeName: item.questionTypeName,
                name: item.name,
                level: item.level,
                levelName: item.levelName,
                category: item.category,
                analysis: item.analysis,
                choices: item.choices,
                checked: false,
                point: null,
              });
            });
          }
        }
      },
      /**
       * @description 题库选择事件
       * @param {Object} objItem
       */
      onChangeBank(objItem) {
        let that = this;
        // 获取章节
        ajaxGet(that, '/api/admin/paper/question/category/' + objItem, null, function(resCategory) {
          // 获取试题
          ajaxGet(that, '/api/admin/paperbank/question/' + objItem, null, function(resQuestion) {
            that.optCategory = ['全部'];
            if (!regNullArray(resCategory)) {
              that.optCategory.push(...resCategory);
            }
            that.allDialogData = resQuestion;
            that.dialogData = resQuestion;
          });
        });
      },
      /**
       * @description 打开新增题目事件
       */
      onOpenBank() {
        let that = this;
        let apiUrl = '/api/admin/paper/question/bank';
        if (!regNull(that.infoForm.courseId)) {
          apiUrl = '/api/admin/paper/question/bank?courseId=' + that.infoForm.courseId;
        }
        ajaxGet(that, apiUrl, null, function(resData) {
          that.dialogVisible = true;
          that.optBank = resData;
        });
      },
      /**
       * @description 快捷
       * @param {Object} that
       */
      onGetFast(that) {
        if (!regNullArray(that.itemData)) {
          that.totalInfo.score = 0;
          that.totalInfo.count = that.itemData.length;
          that.itemData.forEach((item) => {
            that.totalInfo.score += parseFloat(item.point);
          });
        }

        ajaxGet(that, '/api/admin/paper/questiontype', null, function(resType) {
          if (!regNullArray(resType)) {
            that.fastData = [];
            let tpColor = ColorData();
            resType.forEach((item, index) => {
              that.fastData.push({
                name: item.Text,
                color: tpColor[index],
                number: that.itemData.filter(list => list.questionType == parseInt(item.Value))
              })
            });
          }
        });
      },
      /**
       * @description 关闭
       */
      handleClose() {
        let that = this;
        that.dialogVisible = false;
        that.dialogData = [];
        that.dialogForm.bankId = null;
        that.dialogForm.category = null;
      },
      /**
       * @description move回调方法
       * @param {Object} e
       * @param {Object} originalEvent
       */
      onMove(e, originalEvent) {
        let that = this;
        // if (e.relatedContext.element.sectionsPerWeek == 0) return false;
        return true;
      },
      /**
       * @description 删除
       * @param {Object} objID
       */
      onDelQuestion(objID) {
        let that = this;
        let tpData = that.itemData.filter(item => item.questionId != objID);
        that.itemData = JSON.parse(JSON.stringify(tpData));
      },
      /**
       * @description 显示正确答案
       * @param {Object} objItem
       */
      onGetAnswer(objItem) {
        let that = this;
        let strAnswer = '';
        objItem.choices.forEach((item, index) => {
          if (item.right) {
            strAnswer += that.optLetter[index] + '、'
          }
        });
        return strAnswer.slice(0, strAnswer.length - 1);
      },

      /**
       * @description 返回事件
       */
      onBack() {
        let that = this;
        back(that);
      },
    },
  };

  function pagingPage(that) {



  }
</script>

<style scoped="scoped" lang="less">
  .cardHeaderCont {
    cursor: move;
    position: relative;

    .card-subCont {
      width: 100%;
      display: block;
      padding-top: 10px;

      .spItem {
        margin-right: 10px;
      }
    }

    .cardTitleCont {
      padding-right: 55px;
      float: inherit;
    }

    .btnDelCont {
      position: absolute;
      top: -5px;
      right: 0px;
    }
  }

  .divQuestionItem {
    border: 2px solid #DCDFE6;
    margin-left: 20px;
    margin-bottom: 15px;
    padding: 15px;
    border-radius: 5px;

    &:hover {
      cursor: pointer;
      border-color: #409EFF;
    }
  }


  .divFloatBox {

    position: fixed;
    top: 100px;
    right: 0;
    z-index: 10;

    .itemAddBox {
      border: 1px solid #c2e7b0;
      cursor: pointer;
      margin-top: 20px;
      background-color: #f0f9eb;
      padding-top: 5px;
      padding-bottom: 5px;
      text-align: center;
      color: #67c23a;
      border-radius: 10px 0 0 10px;

      .divIcon {
        font-size: 22px;
      }

      .divName {
        font-size: 12px;
      }

      &:hover {
        border: 1px solid #67c23a;
        background-color: #67c23a;
        color: #FFFFFF;
      }
    }

    .itemEditBox {
      border: 1px solid #e6a23c;
      cursor: pointer;
      margin-top: 1px;
      background-color: #fdf6ec;
      padding-top: 5px;
      padding-bottom: 5px;
      text-align: center;
      color: #e6a23c;
      border-radius: 10px 0 0 10px;

      .divIcon {
        font-size: 22px;
      }

      .divName {
        font-size: 12px;
      }

      &:hover {
        border: 1px solid #e6a23c;
        background-color: #e6a23c;
        color: #FFFFFF;
      }
    }

    .itemBox {
      height: 60px;
      width: 60px;
      display: flex;
      border-radius: 10px 0 0 10px;
      border: 3px solid #eeeeee;
      background-color: #ffffff;

      .divName {
        text-align: center;
        writing-mode: vertical-lr;
        font-size: 12px;
        color: #ffffff;
        padding-left: 2px;
        background-color: #EEEEEE;
      }

      .divNum {
        text-align: center;
        flex: 1;
        font-family: 'OswaldLight';
        font-weight: bold;
        color: #EEEEEE;
      }
    }

    .fastTotal {
      border-color: #e83e8c;

      .divName {
        background-color: #e83e8c;
      }

      .divNum {
        color: #e83e8c;
      }
    }




  }



  .selTitleBox {
    font-size: 14px;

    .spTitle {
      color: #303133;
    }
  }

  .selBodyBox {
    padding-top: 5px;
  }


  .color-black {
    color: #303133;
  }

  .dialogBox {
    border-bottom: 1px dotted #ddd;
    margin-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;

    &:last-child {
      border-bottom: none;
    }

    .divTitle {
      display: flex;
      margin-bottom: 15px;

      .divName {
        color: #303133;
        flex: 1;
      }

      .divTag {
        text-align: right;
      }
    }

    .divBody {
      color: #909399;
      padding-left: 20px;
    }
  }



  .divTopicItem {
    display: flex;

    .divChecked {
      margin-right: 5px;
    }

    .divInput {
      width: 50%;
    }

    .divBtn {
      margin-left: 10px;
    }
  }

  .colItemBox {
    padding-bottom: 15px;
    color: #909399;
  }

  .divTitleBox {
    text-align: center;
    font-size: 1.5rem;
    color: #303133;
  }

  .divSubTitle {
    text-align: center;
    padding-top: 15px;
    padding-bottom: 5px;
    color: #909399;
    font-size: 14px;
  }

  .divDateCont {
    text-align: center;
    color: #606266;
  }

  .divDesc {
    padding: 30px;
    font-size: 14px;
    color: #606266;
  }

  .spIcon {
    width: 5px;
    height: 20px;
    border-radius: 5px;
    background-image: linear-gradient(#4545FF, #2D8EFF);
  }

  .spIconTwo {
    width: 5px;
    height: 28px;
    border-radius: 5px;
    background-image: linear-gradient(#4545FF, #2D8EFF);
  }
</style>

<style lang="less">
  .tbDialogTable {
    label {
      margin-bottom: 0 !important;
    }
  }

  .tbDialogTable .headerColor {
    color: #909399 !important;
    background: #f5f7fa !important;
  }

  .tdCheckBox {
    .el-checkbox__inner {
      width: 24px;
      height: 24px;
    }

    .el-checkbox__inner::after {
      font-weight: bolder;
      height: 14px;
      left: 8px;
    }
  }
</style>
